import { IOption } from "interface";
import i18n from "locales/i18n";
import { useEffect, useRef, useState } from "react";
import "./select.scss";

type ISelect = {
  list: any[];
  name: string;
  styles?: string;
  defaultValue: any;
  dataList?: string[] | null;
  disabled?: boolean;
  option?: string;
  onChange?(item: any): void;
};

export default function Select({
  dataList,
  list,
  name,
  styles = "",
  defaultValue,
  disabled,
  option,
  onChange,
}: ISelect) {
  const selectRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const ulRef = useRef<HTMLUListElement>(null);
  const langCd = i18n.language;

  const [value, setValue] = useState<any>();

  const onSelect = (item: any) => {
    onChange && onChange(item);
  };

  //OUTSIDE CLICK
  const outSideClick = (e: any) => {
    if (
      selectRef.current &&
      !selectRef.current.contains(e.target) &&
      ulRef.current
    ) {
      selectRef.current.classList.remove("rotate");
      // ulRef.current.classList.add("hidden");
    }
  };

  useEffect(() => {
    if (option) {
      const newvalue = list.find((li) => {
        return li.code + "" === option;
      });
      setValue(newvalue);
    }
  }, [option]);

  useEffect(() => {
    if (defaultValue) {
      if (defaultValue[langCd as keyof IOption]) {
        setValue(defaultValue);
      } else {
        setValue({
          ko: defaultValue,
          en: defaultValue,
          value: defaultValue,
          code: 0,
        });
      }
    }
  }, [defaultValue]);

  useEffect(() => {
    document.addEventListener("click", outSideClick);

    return () => {
      document.removeEventListener("click", outSideClick);
    };
  }, []);

  return (
    <div className={"select" + " " + styles} ref={selectRef}>
      <input
        type="text"
        role="select"
        ref={inputRef}
        name={name}
        value={
          (value
            ? value[langCd as keyof IOption]
            : list[0][langCd as keyof IOption]) ?? "선택하세요"
        }
        readOnly
        onClick={(e) => {
          if (ulRef.current && selectRef.current) {
            const classList = Array.from(selectRef.current.classList);

            if (!classList.includes("rotate")) {
              selectRef.current.classList.add("rotate");
              ulRef.current.classList.remove("hidden");
            }
            if (classList.includes("rotate")) {
              selectRef.current.classList.remove("rotate");
              ulRef.current.classList.add("hidden");
            }
            Array.from(ulRef.current?.children).forEach((li: any) => {
              if (li.dataset.code !== e.currentTarget.dataset.code) {
                li.removeAttribute("data-checked");
              }
            });
          }
        }}
        onChange={() => {}}
        disabled={disabled}
      />

      <ul ref={ulRef} className="hidden">
        {list.map((item, index) => {
          return (
            <li
              key={index}
              data-code={item.code}
              onClick={(e) => {
                e.currentTarget.setAttribute("data-checked", "true");
                if (inputRef.current && ulRef.current) {
                  inputRef.current.value = item[langCd as keyof IOption];
                  inputRef.current.setAttribute("data-code", item.code);

                  if (selectRef.current) {
                    selectRef.current.classList.remove("rotate");
                    ulRef.current.classList.add("hidden");
                  }
                }

                if (inputRef.current) {
                  const { type } = inputRef.current.dataset;

                  type === "C" &&
                    inputRef.current.setAttribute("data-type", "U");
                }
                setValue(item);
                onSelect(item);
              }}
            >
              {item[langCd as keyof IOption]}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
